// extracted by mini-css-extract-plugin
export var discard = "_35-3";
export var muiTooltipTooltip = "_35-5";
export var notificationBar = "_35-2";
export var saveButtonHoverSlotWrapper = "_35-4";
export var show = "_35-1";
export var spacer = "_35-0";